import { RefObject, createContext, useContext } from 'react'

import { DEFAULT_EDITOR_TOOL } from '@editor/config/constants'
import { Editor } from '@editor/interfaces/interfaces'
import { ArcballControls } from '@editor/services/threejs'
import { PerspectiveCamera, Scene } from 'three'

// To prevent mis-reuse of this object, use this function to create a new object
export const INITIAL_SHAPE_STATE = () => ({
  cylinders: [],
  tori: [],
  planes: [],
  cuboid: [],
  polygons: [],
})
const initialState: Editor = {
  sceneRef: { current: null } as RefObject<Scene | null>,
  cameraRef: { current: null } as RefObject<PerspectiveCamera | null>,
  arcballControlsRef: {} as RefObject<ArcballControls | null>,

  pointSelectionPlane: null,
  setPointSelectionPlane: () => null,

  pointProjectionPlane: null,
  setPointProjectionPlane: () => null,

  pointSelectionObjectIdsRef: { current: [] } as RefObject<string[]>,

  changeCuboidDirection: () => null,
  changeIsJobRunning: () => null,
  changeIsToolProcessing: () => null,
  changeSelectedShapeIds: () => null,

  selectedTool: DEFAULT_EDITOR_TOOL,
  prevSelectedTool: DEFAULT_EDITOR_TOOL,
  prevPrevSelectedTool: DEFAULT_EDITOR_TOOL,
  isPreviousTool: () => false,
  changeTool: () => null,
  changeSubTool: () => null,

  initCompleted: false,
  isToolProcessing: false,
  updateMeshRefs: () => null,
  updateElementLayerOrders: () => null,
  changeCollidingShapeIds: () => null,
  collidingShapeIds: [],
  selectionBoundaryBoxVectors: [],
  focusCamera: () => null,
  focusCameraDirectional: () => null,
}

export const EditorContext = createContext(initialState)
export const useEditorContext = () => useContext(EditorContext)
